<script setup lang="ts">
import { ref, onMounted, defineProps } from "vue";
import axios from "axios";

defineProps<{
  displayMode?: "badge" | "text";
}>();

const version = ref<string>("");
const loading = ref<boolean>(true);

const webVersion = process.env.VUE_APP_WEB_VERSION;

let postUrl = "";

if (process.env.NODE_ENV === "development") {
  postUrl = process.env.VUE_APP_LOCAL_URL;
}

onMounted(async () => {
  try {
    const response = await axios.get(postUrl + "/api/version/");
    version.value = response.data.version;
  } catch (error) {
    console.error("Failed to fetch version:", error);
    version.value = "unknown";
  } finally {
    loading.value = false;
  }
});
</script>

<template>
  <div v-if="!loading" class="version-display">
    <span v-if="displayMode === 'badge'" class="version-badge">
      v{{ version }}
    </span>
    <span v-else class="version-text">
      PICNIC API version {{ version }}, release {{ webVersion }}
    </span>
  </div>
</template>

<style scoped>
.version-display {
  display: inline-block;
}

.version-badge {
  background-color: #2eab9f;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.85em;
  font-weight: 500;
  display: inline-block;
  letter-spacing: 0.3px;
}

.version-text {
  color: #666;
  font-size: 0.9em;
  font-style: italic;
}
</style>
